import React, { useEffect, useState } from "react";
import "./Testmonials.css";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import TestmonialBox from "./TestmonialBox";
import { Axios } from "../../../Components/Helpers/Axios";
import { useTranslation } from "react-i18next";
const Testmonials = () => {
  const {t ,i18n} = useTranslation()
const [data , setData] = useState([]);
useEffect(()=>{
  Axios.get('/Testimonials').then(data=>setData(data.data.data))
},[])



  const [resize, setResize] = useState(window.innerWidth);
  useEffect(() => {
    const resizeWidth = () => {
      setResize(window.innerWidth);
    };
    window.addEventListener("resize", resizeWidth);
    return () => {
      window.removeEventListener("resize", resizeWidth);
    };
  }, [window.innerWidth]);
  return (
    <div className="Testmonials  ">
      <div className="text ">
        <h3>{t("testmonials")}</h3>
        <p className="mt-4">
        {t("Because results speak louder than promises. Here’s what our partners say about working with SunMed real stories, real impact and long-term trust built on creative excellence.")}

        </p>
      </div>
      <div className="t-container mt-[10vh]">
        <Swiper
          slidesPerView={"auto"}
          centeredSlides={resize > 550 ? false : true}
          pagination={true}
          spaceBetween={40}
          modules={[Pagination]}
          className="t-swiper"
        >

          {
            data.map((data,index)=>(

          <SwiperSlide>
            <TestmonialBox img={data.image} content={data.content} name={data.name} />
          </SwiperSlide>

            ))
          }

          {/* <SwiperSlide>
            <TestmonialBox />
          </SwiperSlide>

          <SwiperSlide>
            <TestmonialBox />
          </SwiperSlide>

          <SwiperSlide>
            <TestmonialBox />
          </SwiperSlide>

          <SwiperSlide>
            <TestmonialBox />
          </SwiperSlide> */}
        </Swiper>
      </div>
    </div>
  );
};

export default Testmonials;
